import React from 'react';
import { styled } from '@linaria/react';
import { DynamicOptionsLoadingProps } from 'next/dynamic';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Spinner } from '@daedalus/atlas/Spinner';
import ImportLoader from './ImportLoader';
const _exp = /*#__PURE__*/() => Flex.Row;
const SpinnerWrapper = /*#__PURE__*/styled(_exp())({
  name: "SpinnerWrapper",
  class: "sw65ojg",
  propsAsIs: true
});
const getLoadingComponent = () => <SpinnerWrapper alignItems="center" justifyContent="center">
    <Spinner size={80} />
  </SpinnerWrapper>;
const SpinnerImportLoader = (props: DynamicOptionsLoadingProps) => <ImportLoader {...props} loadingComponent={getLoadingComponent()} />;
export default SpinnerImportLoader;

require("./SpinnerImportLoader.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SpinnerImportLoader.tsx");